import { render } from "./BaseUpdate.vue?vue&type=template&id=59912731&scoped=true&ts=true"
import script from "./BaseUpdate.vue?vue&type=script&lang=ts"
export * from "./BaseUpdate.vue?vue&type=script&lang=ts"

import "./BaseUpdate.vue?vue&type=style&index=0&id=59912731&lang=scss&scoped=true"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59912731"]])

export default __exports__